export default __webpack_public_path__ + "assembly94c9c9e.png";